import { BG_PIXEL_TO_TILEMAP_POSITION, PIXEL_NAME, PIXEL_TO_TILEMAP_POSITION } from '../utils/constants'
import LevelTest from './levels/level_ki_finale'
import Level1 from './levels/level_1'
import Level2 from './levels/level_2'
import Level3 from './levels/level_3'
import Level4 from './levels/level_4'
import Level5 from './levels/level_5'
import Level6 from './levels/level_6'
import Level7 from './levels/level_7'
import Level8 from './levels/level_8'
import Level9 from './levels/level_9'
import Level10 from './levels/level_10'
import Level11 from './levels/level_11'
import Level12 from './levels/level_12'
import Level13 from './levels/level_13'
import Level14 from './levels/level_14'
import Level15 from './levels/level_15'
import Level16 from './levels/level_16'
import Level17 from './levels/level_17'
import Level18 from './levels/level_18'
import Maze1 from './levels/Maze_1'
import LevelFinale from './levels/level_ki_finale'
import mazegenerator from 'generate-maze'
import { textureToMapConfig } from '../utils/helpers'
import Deco from './objects/Deco'
import LevelMaze2 from './levels/Maze_2'

export const LEVELS = [
  '',
  LevelTest,
  Level1,
  Level2,
  Level3,
  Level4,
  Level5,
  Level6,
  Level7,
  Level8,
  Level9,
  Level10,
  Level11,
  Level12,
  Maze1,
  Level13,
  Level14,
  Level15,
  Level16,
  Level17,
  LevelMaze2,
  Level18,
  LevelFinale,
]

export const getNextLevel = levelKey => {
  let currentIndex = LEVELS.findIndex(l => l.key === levelKey)
  let nextLevel
  do {
    currentIndex++
    nextLevel = LEVELS[currentIndex]
  } while(typeof nextLevel === 'string' || currentIndex > LEVELS.length)

  return nextLevel.key
}

export default class LevelManager {
  constructor(scene, currentLevelName = '') {
    this.currentName = currentLevelName
    this.currentIndex = LEVELS.findIndex(l => l.id === this.currentName)
    this.scene = scene
    this.start()
  }
  
  async start() {
    const Level = LEVELS.find(l => l.key === this.currentName)
    this.current = new Level()
    const [mapConfig, bgConfig] = this.generateConfig()
    this.current.config = mapConfig
    this.current.bgConfig = bgConfig
    this.map = this.createMap()
    this.createBackground()
    await this.current.connectToScene(this.scene)
    this.scene.cameras.main.once('camerafadeincomplete', () => {
      // this.current.resume()
      this.scene.events.emit('levelstart')
    })
    this.current.pause()
  }
  restart() {
    this.scene.cameras.main.fade(500, 0, 0, 0)
    this.scene.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.events.off('player_moves')
      this.current.destroy()
      this.scene.children.list.forEach(ch => {
        ch.destroy()
      })
      this.scene.rules.destroy()
      this.scene.ui.destroy()
      this.scene.levels.current?.destroy()
      this.scene.scene.restart({ levelName: this.currentName, isRestart: true })
      
    })
  }

  next() {
    // destroy and unload
    this.currentIndex += 1
    if(typeof LEVELS[this.currentIndex] === 'string' && LEVELS[this.currentIndex].includes('cinematic')) {
      this.scene.scene.start('ConnectorScene', { id: this.currentIndex, name: LEVELS[this.currentIndex]})
    } else if (LEVELS[this.currentIndex]) {
      this.start()
    } else {
      this.scene.scene.start('MenuScene')
    }

  }

  generateConfig() {
    const scene = this.scene
    const levelId = this.current.constructor.key
    
    let levelConfig
    let bgConfig
    if(this.current.isMaze) {
      // Generate a maze
      // Width == 8, height == 4, maze edges are closed, using random seed 
      const MAZE_WIDTH = 40
      const MAZE_HEIGHT = 10
      const STARTING_ROW = 3 // move 3 blocks down to avoid hud overlap
      levelConfig = Array(2*MAZE_HEIGHT + STARTING_ROW +1 ).fill('000000').map(r => Array(2*MAZE_WIDTH+1).fill('000000'))
      const maze = mazegenerator(MAZE_WIDTH, MAZE_HEIGHT, true, Math.round(Math.random() * Math.pow(10, 8)))
      maze.forEach(row => {
        row.forEach(cell => {
          const j = 2 * cell.x + 1
          const i = 2 * cell.y + 1 + STARTING_ROW
          // top
          levelConfig[i-1][j] = cell.top ? PIXEL_NAME.WALL : PIXEL_NAME.EMPTY
          if(cell.top) {
            levelConfig[i-1][j+1] = PIXEL_NAME.WALL
            levelConfig[i-1][j-1] = PIXEL_NAME.WALL
          }
          // right
          levelConfig[i][j+1] = cell.right ? PIXEL_NAME.WALL : PIXEL_NAME.EMPTY
          if(cell.right) {
            levelConfig[i+1][j+1] = PIXEL_NAME.WALL
            levelConfig[i-1][j+1] = PIXEL_NAME.WALL
          }
          // bottom
          levelConfig[i+1][j] = cell.bottom ? PIXEL_NAME.WALL : PIXEL_NAME.EMPTY
          if(cell.bottom) {
            levelConfig[i+1][j+1] = PIXEL_NAME.WALL
            levelConfig[i+1][j-1] = PIXEL_NAME.WALL
          }
          // left
          levelConfig[i][j-1] = cell.left ? PIXEL_NAME.WALL : PIXEL_NAME.EMPTY
          if(cell.left) {
            levelConfig[i+1][j-1] = PIXEL_NAME.WALL
            levelConfig[i-1][j-1] = PIXEL_NAME.WALL
          }
          // center
          levelConfig[i][j] = PIXEL_NAME.EMPTY
        })
      })
      levelConfig[STARTING_ROW + 1][1] = PIXEL_NAME.PLAYER
      // levelConfig[STARTING_ROW-1][levelConfig[0].length - 2] = PIXEL_NAME.PLAYER
      // levelConfig[STARTING_ROW+1][1] = PIXEL_NAME.BRO
      levelConfig[STARTING_ROW + 2][1] = PIXEL_NAME.DWARF
      levelConfig[STARTING_ROW + 2][2] = PIXEL_NAME.EMPTY // dwarf position to move away the path

      // try to set an exit
      const rowIdx = levelConfig.findIndex((r) => {
          // ignores 3 top spaces saved for HUD
          const lastColTile = r.slice(-1).pop()
          
          const isNotTopBufferSpace = lastColTile !== PIXEL_NAME.EMPTY
          // gets last 2 position skiping last one (column) that is always a wall
          const lastThreeBeforLastTile = r.slice(-4, -1)
          // const tileIsEmpty = lastThreeBeforLastTile[2] === PIXEL_NAME.EMPTY
          // const emptyPrecededByEmpty = tileIsEmpty && lastThreeBeforLastTile[0] === PIXEL_NAME.EMPTY
          const threeEmptyInARow = lastThreeBeforLastTile.every(t => t === PIXEL_NAME.EMPTY)
          // finds first row with 2 consecutive empty spaces into the maze
          return isNotTopBufferSpace && threeEmptyInARow
        })
      
      levelConfig[rowIdx][levelConfig[0].length - 1] = PIXEL_NAME.EXIT
      this.buildWallsAroundGate(levelConfig)
    } else {
      levelConfig = textureToMapConfig(scene.textures, levelId)
      // decorates gate
      bgConfig = textureToMapConfig(scene.textures, `${levelId}_bg`)
    }
    return [levelConfig, bgConfig]
  }
  buildWallsAroundGate(config) {
    config.forEach((row, y) => {
      row.forEach((el, x) => {
        if(el === PIXEL_NAME.EXIT) {
          config[y-1][x] = PIXEL_NAME.DEBRIS
          config[y-1][x-1] = PIXEL_NAME.DEBRIS
          config[y-1][x-2] = PIXEL_NAME.DEBRIS

          config[y+1][x] = PIXEL_NAME.DEBRIS
          config[y+1][x-1] = PIXEL_NAME.DEBRIS
          config[y+1][x-2] = PIXEL_NAME.DEBRIS

        }
      })
    })

  }
  createBackground() {
    let image = this.scene.add.image(0, 0, 'Stage1_bg')
    let scaleX = this.scene.cameras.main.width / image.width
    let scaleY = this.scene.cameras.main.height / image.height
    let scale = Math.max(scaleX, scaleY)
    image.setOrigin(0, 0)
    image.setScale(scale * 1.5).setScrollFactor(0.1)
    image.name = 'level_background_art'
    image.depth = -2
  }

  createMap() {
    const scene = this.scene
    const levelData = this.current
    const SCALE = scene.data.get('custom_scale')
    const camera = this.scene.cameras.main

    let map = this.map
    let mapZ2 = this.mapZ2
    let underlayMap = this.underlayMap
    if(map && map.scene) {
      map.destroy()
      mapZ2.destroy()
      underlayMap.destroy()
    }

    // Creating a blank tilemap with dimensions matching the dungeon
    map = scene.make.tilemap({ tileWidth: 20, tileHeight: 20, width: levelData.config[0].length, height: levelData.config.length });
    mapZ2 = scene.make.tilemap({ tileWidth: 20, tileHeight: 20, width: levelData.config[0].length, height: levelData.config.length });
    underlayMap = scene.make.tilemap({ tileWidth: 20, tileHeight: 20, width: levelData.config[0].length, height: levelData.config.length });

    window.map = map
    // addTilesetImage: function (tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid)
    let tileset = map.addTilesetImage('tiles', 'main-tiles', 20, 20, 1, 2);
    let tilesetGates = map.addTilesetImage('tiles-gates', 'gates-tiles', 20, 20, 1, 2);
    let tilesetZ2 = mapZ2.addTilesetImage('tiles-z2', 'gates-tiles', 20, 20, 1, 2);
    let underlaytileset = underlayMap.addTilesetImage('under-tiles', 'main-tiles', 20, 20, 1, 2);

    let layer = map.createBlankLayer('layer_1', tileset);
    layer.name = 'layer_1'
    layer.depth = 0
    let layer2 = map.createBlankLayer('layer_2', tilesetGates);
    layer2.name = 'layer_2'
    layer2.depth = 0

    let layerZ2 = mapZ2.createBlankLayer('layer_1z2', tilesetZ2);
    layerZ2.name = 'layer_1z2'
    layerZ2.depth = 5

    let underlayer = underlayMap.createBlankLayer('layer_0', underlaytileset);
    underlayer.name = 'layer_0'
    underlayer.depth = -1
    
    layer.setScale(SCALE)
    layer2.setScale(SCALE)
    layerZ2.setScale(SCALE)
    underlayer.setScale(SCALE * 1.01)// fix glitch of empty line between tiles for specific camera positions
    underlayer.setScrollFactor(0.95)

    levelData.config.forEach((row, x) => {
      row.forEach((el, y) => {
        let tile = el
        if(levelData.bgConfig) {
          let bgTile = levelData.bgConfig[x][y]
          underlayMap.putTileAt(BG_PIXEL_TO_TILEMAP_POSITION[bgTile], y, x)
        }

        if (
          [
            PIXEL_NAME.WALL,
            PIXEL_NAME.DEBRIS,
            PIXEL_NAME.GROUND,
            PIXEL_NAME.ART,
            PIXEL_NAME.ART2,
            PIXEL_NAME.EXIT,
            PIXEL_NAME.TORCH,
          ].includes(tile)
        ) {
          if (tile === PIXEL_NAME.WALL || tile === PIXEL_NAME.TORCH) {
            if(this.current.isMaze) {
              tile = 1
            } else {
              tile = PIXEL_TO_TILEMAP_POSITION.calculateWallTileWithNeighbours(x, y, levelData.config)
            }
            map.putTileAt(tile, y, x, false, 'layer_1')
          } else if (tile === PIXEL_NAME.DEBRIS) {
            map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile], y, x, false, 'layer_1')
            // map.putTileAt(1, y, x, false, 'layer_1')
          } else if (tile === PIXEL_NAME.GROUND) {
            tile = PIXEL_TO_TILEMAP_POSITION.calculateGroundTileWithNeighbours(x, y, levelData.config)
            map.putTileAt(tile, y, x, false, 'layer_1')
          } else if ([PIXEL_NAME.ART, PIXEL_NAME.ART2].includes(tile)) {
            map.putTileAt(21, y, x, false, 'layer_1')
            // two consecutives art tiles means flix horizontal
            const isFlipX = [PIXEL_NAME.ART, PIXEL_NAME.ART2].includes(levelData.config[x][y+1])
            const isFlipFlag = [PIXEL_NAME.ART, PIXEL_NAME.ART2].includes(levelData.config[x][y-1])
            if(isFlipFlag) return false
            if(isFlipX) {
              map.putTileAt(21, y + 1, x, false, 'layer_1')

              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 3, y-1, x, false, 'layer_2').setFlipX(true)
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 2, y, x, false, 'layer_2').setFlipX(true)
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 1, y+1, x, false, 'layer_2').setFlipX(true)
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile], y+2, x, false, 'layer_2').setFlipX(true)
              
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10 + 3, y-1, x + 1, false, 'layer_2').setFlipX(true)
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10 + 2, y, x + 1, false, 'layer_2').setFlipX(true)
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10 + 1, y+1, x + 1, false, 'layer_2').setFlipX(true)
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10, y+2, x + 1, false, 'layer_2').setFlipX(true)
            } else {
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile], y, x, false, 'layer_2')
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 1, y + 1, x, false, 'layer_2')
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 2, y + 2, x, false, 'layer_2')
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 3, y + 3, x, false, 'layer_2')
              
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10, y, x + 1, false, 'layer_2')
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10 + 1, y + 1, x + 1, false, 'layer_2')
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10 + 2, y + 2, x + 1, false, 'layer_2')
              map.putTileAt(PIXEL_TO_TILEMAP_POSITION[tile] + 10 + 3, y + 3, x + 1, false, 'layer_2')
            }
          } else if (tile === PIXEL_NAME.EXIT) {
            const POSITION_EXIT = PIXEL_TO_TILEMAP_POSITION[tile + (this.current.id === 'level_ki_finale' ? '_2' : '_1')]
            // entrance behind user
            map.putTileAt(POSITION_EXIT - 3, y - 1, x, false, 'layer_2')
            // entrance behind and above user
            // remove original tile
            // map.putTileAt(PIXEL_TO_TILEMAP_POSITION[PIXEL_NAME.EMPTY] - 10 - 4, y - 2, x - 1, false, 'layer_1')
            map.putTileAt(POSITION_EXIT - 10 - 4, y - 2, x - 1, false, 'layer_2')
            // entrance behind and below user
            map.putTileAt(POSITION_EXIT - 4, y - 2, x, false, 'layer_2')
            /**
             * 1 2 3
             * 4 5 6
             * 7 8 9
             */
            // 1
            // let tileKind = PIXEL_TO_TILEMAP_POSITION.calculateWallTileWithNeighbours(x, y, levelData.config)
            // map.putTileAt(PIXEL_TO_TILEMAP_POSITION[PIXEL_NAME.WALL], y - 2, x - 1, false, 'layer_1')
            mapZ2.putTileAt(POSITION_EXIT - 10 - 2, y - 2, x - 1)
            // 2
            // map.putTileAt(PIXEL_TO_TILEMAP_POSITION[PIXEL_NAME.WALL], y - 1, x - 1, false, 'layer_1')
            mapZ2.putTileAt(POSITION_EXIT - 10 - 1, y - 1, x - 1)
            // 3
            mapZ2.putTileAt(POSITION_EXIT - 10, y, x - 1)
            // 4
            mapZ2.putTileAt(POSITION_EXIT - 2, y - 2, x)
            // 5
            mapZ2.putTileAt(POSITION_EXIT - 1, y - 1, x)
            // 6
            mapZ2.putTileAt(POSITION_EXIT, y, x)
            // 7
            mapZ2.putTileAt(POSITION_EXIT + 10 - 2 , y - 2, x + 1)
            // 8
            mapZ2.putTileAt(POSITION_EXIT + 10 - 1, y - 1, x + 1)
            // 9
            mapZ2.putTileAt(POSITION_EXIT + 10, y, x + 1)
          }
        } else if ([PIXEL_NAME.HANGING_2, PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5].includes(tile)) {
          // place a wall in layer_1
          const tileKind = PIXEL_TO_TILEMAP_POSITION.calculateWallTileWithNeighbours(x, y, levelData.config)
          map.putTileAt(tileKind, y, x, false, 'layer_1')
          levelData.config[x][y] = PIXEL_NAME.WALL

          
          // place 1st hanging sprite in depth = 5
          let pos = { x: y, y: x } // inverse pos due to config loop: cols by row
          let nextSprite = 'liana_start'
          let hanging = this.scene.add.sprite(48, 16)
          .setOrigin(0, 0.2)
          .play(nextSprite)
          hanging.setScale(layer.scaleX)
          hanging.x = map.tileToWorldX(pos.x)
          hanging.y = map.tileToWorldY(pos.y)
          hanging.depth = 5

          let element = new Deco(tile, this.current)
          element.position = {...pos}
          element.alien = hanging
          levelData.decorationElements[`${pos.x}-${pos.y}`] = element
          

          // place hanging 2nd sprite
          pos.y++
          if([PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5].includes(tile)) {
            nextSprite = 'liana_middle'
          } else {
            nextSprite = 'liana_end'
          }
          hanging = this.scene.add.sprite(48, 16)
          .setOrigin(0, 0.2)
          .play(nextSprite)
          hanging.setScale(layer.scaleX)
          hanging.x = map.tileToWorldX(pos.x)
          hanging.y = map.tileToWorldY(pos.y)
          hanging.depth = 5

          element = new Deco(tile, this.current)
          element.position = {...pos}
          element.alien = hanging
          levelData.decorationElements[`${pos.x}-${pos.y}`] = element

          // place hanging 3rd sprite?
          if([PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5].includes(tile)) {
            pos.y++
            nextSprite = PIXEL_NAME.HANGING_3 === tile ? 'liana_end' : 'liana_middle'

            hanging = this.scene.add.sprite(48, 16)
            .setOrigin(0, 0.2)
            .play(nextSprite)
            hanging.setScale(layer.scaleX)
            hanging.x = map.tileToWorldX(pos.x)
            hanging.y = map.tileToWorldY(pos.y)
            hanging.depth = 5

            element = new Deco(tile, this.current)
            element.position = {...pos}
            element.alien = hanging
            levelData.decorationElements[`${pos.x}-${pos.y}`] = element
          }
          

          // place hanging 4th sprite
          if([PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5].includes(tile)) {
            pos.y++
            nextSprite = PIXEL_NAME.HANGING_4 === tile ? 'liana_end' : 'liana_middle'
            hanging = this.scene.add.sprite(48, 16)
            .setOrigin(0, 0.2)
            .play(nextSprite)
            hanging.setScale(layer.scaleX)
            hanging.x = map.tileToWorldX(pos.x)
            hanging.y = map.tileToWorldY(pos.y)
            hanging.depth = 5

            element = new Deco(tile, this.current)
            element.position = {...pos}
            element.alien = hanging
            levelData.decorationElements[`${pos.x}-${pos.y}`] = element
          }

          // place hanging 5th sprite
          if([PIXEL_NAME.HANGING_5].includes(tile)) {
            pos.y++
            nextSprite = 'liana_end'
            hanging = this.scene.add.sprite(48, 16)
            .setOrigin(0, 0.2)
            .play(nextSprite)
            hanging.setScale(layer.scaleX)
            hanging.x = map.tileToWorldX(pos.x)
            hanging.y = map.tileToWorldY(pos.y)
            hanging.depth = 5

            element = new Deco(tile, this.current)
            element.position = {...pos}
            element.alien = hanging
            levelData.decorationElements[`${pos.x}-${pos.y}`] = element
          }

        } else {
          if(!levelData.bgConfig) {
            map.putTileAt(PIXEL_TO_TILEMAP_POSITION[PIXEL_NAME.EMPTY], y, x, false, 'layer_1')
          }
        }
      })
    })

    // set up camera
    camera.setBounds(0, 0, layer.width * layer.scaleX, layer.height * layer.scaleY);
    camera.zoom = 1

    this.underlayMap = underlayMap
    this.mapZ2 = mapZ2
    return map
  }
}